<div class="col-sm-12 coldx" >
  <h3 class="title1level" style="margin-bottom: 20px;">{{ formTitle }}</h3>
  <ng-template [ngIf]="!secondStep">
    <div class="container_tab_nav">
      <ul
        role="tablist"
        [ngClass]="isMain ? 'nav nav-tabs two' : 'nav nav-tabs one'"
      >
        <li *ngIf="isMain" class="tab-link-nav" role="presentation">
          <button
            type="button"
            role="tab"
            id="tab-search-doc-add"
            class="btn-link"
            [class.active]="isSearchTabActive"
            [class.inactive]="!isSearchTabActive"
            [attr.aria-selected]="isSearchTabActive"
            (click)="setActiveTab(true)"
          >
            Cerca su E-Grammata
          </button>
        </li>

        <li role="presentation" class="tab-link-nav">
          <button
            type="button"
            role="tab"
            id="tab-insert-doc-add"
            class="btn-link"
            [class.active]="!isSearchTabActive"
            [class.inactive]="isSearchTabActive"
            [attr.aria-selected]="!isSearchTabActive"
            (click)="setActiveTab(false)"
          >
            Inserisci nuovo
          </button>
        </li>
      </ul>
      <div class="tab-content">
        <div *ngIf="isMain" id="tabcontent70" class="tab-pane fade" [ngClass]="{'active in': isSearchTabActive}">
          <app-protocol-fascicolo-search #protocolSearch [fascicolo]="fascicolo" [idPratica]="praticaId" [isDocumentazione]="true" (onImport)="doImport($event)"/>
        </div>
        <div id="tabcontent80" class="tab-pane fade" [ngClass]="{'active in': !isSearchTabActive || !isMain}">
          <ng-template [ngIf]="entityList && !isMain">
            <form class="cerca_grey">
              <div class="row">
                <p class="col-sm-12">
                  <label for="cerca-doc-add">Cerca</label> <input id="cerca-doc-add" type="text" #searchItem (keyup)="0" class="form-control"
                    placeholder="Cerca" />
                </p>
              </div>
            </form>
            <ul id="controparticollapse" class="controparti">
              <ng-template [ngIf]="controparte">
                <ng-template ngFor let-entity
                  [ngForOf]="entityList | searchFilter : searchItem.value : 'parte.nominativo'">
                  <li class="panel" add_doc_to_controparte [entity]="entity" (onClickAddToEntity)="getEntity($event)">
                  </li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="patologia">
                <ng-template ngFor let-entity [ngForOf]="entityList">
                  <li class="panel" add_doc_to_patologia [entity]="entity" (onClickAddToEntity)="getEntity($event)">
                  </li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="schedaRecupero">
                <ng-template ngFor let-entity
                  [ngForOf]="entityList | searchFilter : searchItem.value : 'esito.numeroEsito'">
                  <li class="panel" add_doc_to_scheda_recupero [entity]="entity"
                    (onClickAddToEntity)="getEntity($event)">
                  </li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="schedaEsecuzione">
                <ng-template ngFor let-entity
                  [ngForOf]="entityList | searchFilter : searchItem.value : 'esito.numeroEsito'">
                  <li class="panel" add_doc_to_scheda_esecuzione [entity]="entity"
                    (onClickAddToEntity)="getEntity($event)">
                  </li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="altraparte">
                <ng-template ngFor let-entity
                  [ngForOf]="entityList | searchFilter : searchItem.value : 'parte.nominativo'">
                  <li class="panel" add_doc_to_altraparte [altraParte]="entity"
                    (onClickAddToEntity)="getEntity($event)"></li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="legaleIncaricato">
                <ng-template ngFor let-entity
                  [ngForOf]="entityList | searchFilter : searchItem.value : 'legale.nominativo'">
                  <li class="panel" add_doc_to_legale [legaleIncaricato]="entity"
                    (onClickAddToEntity)="getEntity($event)">
                  </li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="scadenza">
                <ng-template ngFor let-entity [ngForOf]="entityList | searchFilter : searchItem.value : 'appunto'">
                  <li class="panel" add_doc_to_scadenza [scadenza]="entity" (onClickAddToEntity)="getEntity($event)">
                  </li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="atto">
                <ng-template ngFor let-entity [ngForOf]="entityList">
                  <li class="panel" add_doc_to_atto [atto]="entity" (onClickAddToEntity)="getEntity($event)"></li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="esito">
                <ng-template ngFor let-entity [ngForOf]="entityList | searchFilter : searchItem.value : 'numeroEsito'">
                  <li class="panel" add_doc_to_esito [esito]="entity" (onClickAddToEntity)="getEntity($event)"></li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="parcella">
                <ng-template ngFor let-entity [ngForOf]="entityList">
                  <li class="panel" add_doc_to_parcella [parcellaGiudiziale]="entity"
                    (onClickAddToEntity)="getEntity($event)"></li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="fattura">
                <ng-template ngFor let-entity [ngForOf]="entityList">
                  <li class="panel" add_doc_to_fattura [fattura]="entity" (onClickAddToEntity)="getEntity($event)"></li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="pagamento">
                <ng-template ngFor let-entity [ngForOf]="entityList" let-i=index>
                  <li class="panel" add_doc_to_pagamento [pagamento]="entity" (onClickAddToEntity)="getEntity($event)"
                    (beneficiarioPagamento)="beneficiarioPagamento =
                $event"></li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="incasso">
                <ng-template ngFor let-entity [ngForOf]="entityList">
                  <li class="panel" add_doc_to_incasso [incasso]="entity" (onClickAddToEntity)="getEntity($event)"></li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="provaScritta">
                <ng-template ngFor let-entity [ngForOf]="entityList">
                  <li class="panel" add_doc_to_provascritta [provaScritta]="entity"
                    (onClickAddToEntity)="getEntity($event)">
                  </li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="titoloEsecutivo">
                <ng-template ngFor let-entity [ngForOf]="entityList | searchFilter : searchItem.value : 'descrizione'">
                  <li class="panel" add_doc_to_titolo [titolo]="entity" (onClickAddToEntity)="getEntity($event)"></li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="beneImmobile">
                <ng-template ngFor let-entity [ngForOf]="entityList">
                  <li class="panel" add_doc_to_bene_immobile [bene]="entity" (onClickAddToEntity)="getEntity($event)">
                  </li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="beneMobile">
                <ng-template ngFor let-entity [ngForOf]="entityList">
                  <li class="panel" add_doc_to_bene_mobile [beneMobile]="entity"
                    (onClickAddToEntity)="getEntity($event)">
                  </li>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="datiPignoramento">
                <ng-template ngFor let-entity [ngForOf]="entityList">
                  <li class="panel" add_doc_to_dati_pignoramento [datiPignoramento]="entity"
                    (onClickAddToEntity)="getEntity($event)">
                  </li>
                </ng-template>
              </ng-template>
            </ul>
          </ng-template>
          <ng-template [ngIf]="isMain && !secondStep">
            <ng-template [ngIf]="aggiungiDocumentoForm && !isSpostaDoc">
              <form #f="ngForm" [formGroup]="aggiungiDocumentoForm">
                <ng-template [ngIf]="!isFolder">
                  <div class="row">
                    <div textInput class="col-sm-6" [labelInput]="'Titolo'" [control]="aggiungiDocumentoForm.controls['titolo']"
                      formControlName="titolo" [(ngModel)]="formRequest.titolo" [mandatory]="true"></div>
                    <div ng-select-combo class="col-sm-6" formControlName="provenienza" [label]="'Provenienza'" [required]="true"
                      [options]="tipiProvenienza" [optionSel]="formRequest.provenienza" [disabled]="atto"
                      (onChangeSel)="formRequest.provenienza = $event; aggiungiDocumentoForm.controls['provenienza'].setValue($event);">
                    </div>
                  </div>
                  <div class="row">
                    <div ng-select-combo class="col-sm-6" formControlName="tipoDocumento" [label]="'Tipo'" [required]="true"
                      [options]="tipiDocumento" [optionSel]="formRequest.tipoDocumento" [disabled]="false"
                      (onChangeSel)="formRequest.tipoDocumento = $event; aggiungiDocumentoForm.controls['tipoDocumento'].setValue($event);">
                    </div>
                    <div datePickerInput class="col-sm-6" [labelInput]="'Data riferimento'" formControlName="dataRiferimento"
                      [(ngModel)]="formRequest.dataRiferimento" [mandatory]="true"
                      [control]="aggiungiDocumentoForm.controls['dataRiferimento']"></div>
                  </div>
                  <hr style="visibility: hidden;">
                  <div class="row">
                    <div ng-select-combo class="col-sm-6" formControlName="tipoVisibilitaDocumento" [label]="'Visibilità documento'" [required]="true"
                         [options]="tipiVisibilitaDocumento" [optionSel]="formRequest.tipoVisibilitaDocumento" [disabled]="false"
                         (onChangeSel)="formRequest.tipoVisibilitaDocumento = $event; aggiungiDocumentoForm.controls['tipoVisibilitaDocumento'].setValue($event);">
                    </div>
                  </div>
                  <hr style="visibility: hidden;">
                  <div class="row">
                    <div textAreaInput class="col-sm-12" [labelInput]="'Note'" formControlName="note"
                      [(ngModel)]="formRequest.note"></div>
                  </div>

                  <div class="row" *ngIf="isOcrEnable">
                    <div class="col-sm-12">
                      <div class="form-group label">
                        <label for="ocr-lbl" class="question-label">Abilita OCR</label>
                      </div>
                      <div class="form-group" style="padding-left: 6px;">
                        <p-inputSwitch inputId="ocr-lbl" [control]="aggiungiDocumentoForm.controls['flagOcr']" [(ngModel)]="formRequest.flagOcr" formControlName="flagOcr"></p-inputSwitch>

                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-10">
                      <div class="row" style="margin-top: 20px;margin-left:3px;margin-bottom: 10px">
                        <div class="alert alert-danger col-sm-10 d-flex align-items-center" *ngIf="loading" role="alert" aria-live="assertive"
                          aria-atomic="true">
                          <i class="bi bi-exclamation-triangle-fill me-2" aria-hidden="true" style="font-size: 1.3rem; margin-right: 8px"></i>

                          <span id="loading-message">
                            Uno o più file sono in caricamento, l'operazione potrebbe richiedere del tempo.
                          </span>

                          <div class="spinner-border text-light ms-2" role="status" aria-label="Caricamento in corso"
                            style="width: 1.5rem; height: 1.5rem; margin-left: 8px">
                            <span class="sr-only">Caricamento...</span>
                          </div>
                        </div>

                        <br>
                        <div class="tg col-sm-12">
                          <ul style="list-style: none; padding: 0;">
                              <li *ngFor="let item of fileUploadList; let index = index" >
                                <app-document-uploaded
                                  [indexFile]="index"
                                  (onExtract)="onExtractArchive($event)"
                                  [tipiDocumentoOptions]="tipiDocumento"
                                  (onReturn)="onDocReturn($event)"
                                  (onRemoveFile)="deleteFile($event.index)"
                                  [file]="item"
                                  [protocol]="false">
                                </app-document-uploaded>
                              </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2" style="margin-top: 20px">
                      <app-upload-tool [standard]="true" [disabled]="loading"  (onChange)="onSearchChange($event)"></app-upload-tool>
                    </div>
                  </div>
                  <div class="row">
                    <p class="mandatory col-sm-12">
                      <em>* Campi obbligatori</em>
                    </p>
                  </div>
                  <div class="row">
                    <p class="col-sm-3 col-xs-6">
                      <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset();">Reset</button>
                    </p>
                    <p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6"  (click)="save();"
                      [labelButton]="'Inserisci e salva'"
                      [disabled]="loading || !canSave">
                    </p>
                  </div>
                </ng-template>
                <!-- NUOVO/MODIFICA NOME CARTELLA -->
                <ng-template [ngIf]="isFolder">
                  <div textInput class="col-sm-6" [labelInput]="'Aggiungi cartella'"
                    [control]="aggiungiDocumentoForm.controls['nomeFile']" formControlName="nomeFile"
                    [(ngModel)]="formRequest.nomeFile" [mandatory]="true">
                  </div>
                  <div class="col-sm-3">
                    <label>&nbsp;</label>
                    <p submitButton class="col-sm-12 col-xs-12" (click)="saveDir();"
                      [labelButton]="editNameDir ? 'Modifica' : 'Crea'" [disabled]="!formRequest.nomeFile || checkNameFile()"></p>
                  </div>
                  <div class="row">
                    <p class="mandatory col-sm-12">
                      <em *ngIf="checkNameFile()"
                        style="top: -20px;  position: relative; font-size: 13px; color: red; display: block; margin-left: 15px;">
                        Non è possibile inserire il carattere <strong>{{separatorePathLogico}}</strong>
                      </em>
                      <em>* Campi obbligatori</em>
                    </p>
                  </div>
                </ng-template>
                <!-- FINE NUOVO/MODIFICA NOME CARTELLA -->
              </form>
            </ng-template>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template [ngIf]="aggiungiDocumentoForm && secondStep && !isSpostaDoc">
    <form #f="ngForm" [formGroup]="aggiungiDocumentoForm">
      <ng-template [ngIf]="!isMain">
        <ng-template [ngIf]="(controparte&&element) || (altraparte&&element)">
          <div class="row" controparte_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="(patologia&&element)">
          <div class="row" patologia_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="atto">
          <div class="row" atto_entity_view [element]="element"></div>
          <!-- END IF ATTO -->
        </ng-template>
        <ng-template [ngIf]="schedaRecupero">
          <div class="row" scheda_recupero_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="schedaEsecuzione">
          <div class="row" scheda_esecuzione_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="legaleIncaricato">
          <div class="row" legale_incaricato_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="scadenza">
          <div class="row" scadenza_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="esito">
          <div class="row" esito_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="parcella">
          <div class="row" parcella_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="fattura">
          <div class="row" fattura_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="pagamento">
          <div class="row" pagamento_entity_view [beneficiarioPagamento]="beneficiarioPagamento" [element]="element">
          </div>
        </ng-template>
        <ng-template [ngIf]="incasso">
          <div class="row" incasso_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="provaScritta">
          <div class="row" provascritta_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="titoloEsecutivo">
          <div class="row" titolo_esecutivo_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="beneImmobile">
          <div class="row" bene_immobile_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="beneMobile">
          <div class="row" bene_mobile_entity_view [element]="element"></div>
        </ng-template>
        <ng-template [ngIf]="datiPignoramento">
          <div class="row" dati_pignoramento_entity_view [element]="element"></div>
        </ng-template> <!-- END IF !MAIN -->
      </ng-template>
      <ng-template [ngIf]="!isFolder">
        <div class="row">
          <div textInput class="col-sm-6" [labelInput]="'Titolo'" [control]="aggiungiDocumentoForm.controls['titolo']"
            formControlName="titolo" [(ngModel)]="formRequest.titolo" [mandatory]="true"></div>
          <div ng-select-combo class="col-sm-6" formControlName="provenienza" [label]="'Provenienza'" [required]="true"
            [options]="tipiProvenienza" [optionSel]="formRequest.provenienza" [disabled]="isCensimentoDocumenti || atto"
            (onChangeSel)="formRequest.provenienza = $event; aggiungiDocumentoForm.controls['provenienza'].setValue($event);">
          </div>
        </div>
        <div class="row">
          <div ng-select-combo class="col-sm-6" formControlName="tipoDocumento" [label]="'Tipo'" [required]="true"
            [options]="tipiDocumento" [optionSel]="formRequest.tipoDocumento" [disabled]="false"
            (onChangeSel)="formRequest.tipoDocumento = $event; aggiungiDocumentoForm.controls['tipoDocumento'].setValue($event);">
          </div>
          <div datePickerInput class="col-sm-6" [labelInput]="'Data riferimento'" formControlName="dataRiferimento"
            [(ngModel)]="formRequest.dataRiferimento" [mandatory]="true"
            [control]="aggiungiDocumentoForm.controls['dataRiferimento']"></div>
        </div>
        <hr style="visibility: hidden;">
        <div class="row">
          <div ng-select-combo class="col-sm-6" formControlName="tipoVisibilitaDocumento" [label]="'Visibilità documento'" [required]="true"
                [options]="tipiVisibilitaDocumento" [optionSel]="formRequest.tipoVisibilitaDocumento" [disabled]="false"
                (onChangeSel)="formRequest.tipoVisibilitaDocumento = $event; aggiungiDocumentoForm.controls['tipoVisibilitaDocumento'].setValue($event);">
          </div>
        </div>
        <hr style="visibility: hidden;">
        <div class="row">
          <div textAreaInput class="col-sm-12" [labelInput]="'Note'" formControlName="note"
            [(ngModel)]="formRequest.note"></div>
        </div>

        <div class="row">
          <div class="col-sm-10">
            <div class="row" style="margin-top: 20px;margin-left:3px;margin-bottom: 10px">
              <div class="alert alert-danger col-sm-10 d-flex align-items-center" *ngIf="loading" role="alert"
                aria-live="assertive" aria-atomic="true">
                <i class="bi bi-exclamation-triangle-fill me-2" aria-hidden="true"
                  style="font-size: 1.3rem; margin-right: 8px"></i>

                <span id="loading-message">
                  Uno o più file sono in caricamento, l'operazione potrebbe richiedere del tempo.
                </span>

                <div class="spinner-border text-light ms-2" role="status" aria-label="Caricamento in corso"
                  style="width: 1.5rem; height: 1.5rem; margin-left: 8px">
                  <span class="sr-only">Caricamento...</span>
                </div>
              </div>

              <br>
              <div class="tg col-sm-12">
                <ul style="list-style: none; padding: 0;">
                  <li *ngFor="let item of fileUploadList; let index = index">
                    <app-document-uploaded
                      [indexFile]="index"
                      [tipiDocumentoOptions]="tipiDocumento"
                      (onReturn)="onDocReturn($event)"
                      (onExtract)="onExtractArchive($event)"
                      (onRemoveFile)="deleteFile($event.index)"
                      [file]="item"
                      [protocol]="false">
                    </app-document-uploaded>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-sm-2" style="margin-top: 20px">
            <app-upload-tool [standard]="true" [disabled]="loading" (onChange)="onSearchChange($event)"></app-upload-tool>
          </div>
        </div>


        <div class="row">
          <p class="mandatory col-sm-12">
            <em>* Campi obbligatori</em>
          </p>
        </div>
        <div class="row">
          <p class="col-sm-3 col-xs-6">
            <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset();">Reset</button>
          </p>
          <p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" (click)="save();"
            [labelButton]="'Inserisci e salva'"
            [disabled]="loading || !canSave"
            >
          </p>
        </div>
      </ng-template>
      <!-- NUOVO/MODIFICA NOME CARTELLA -->
      <ng-template [ngIf]="isFolder">
        <div textInput class="col-sm-6" [labelInput]="'Aggiungi cartella'"
          [control]="aggiungiDocumentoForm.controls['nomeFile']" formControlName="nomeFile"
          [(ngModel)]="formRequest.nomeFile" [mandatory]="true">
        </div>
        <div class="col-sm-3">
          <label>&nbsp;</label>
          <p submitButton class="col-sm-12 col-xs-12" (click)="saveDir();"
            [labelButton]="editNameDir ? 'Modifica' : 'Crea'" [disabled]="!formRequest.nomeFile || checkNameFile()"></p>
        </div>
        <div class="row">
          <p class="mandatory col-sm-12">
            <em *ngIf="checkNameFile()"
              style="top: -20px;  position: relative; font-size: 13px; color: red; display: block; margin-left: 15px;">
              Non è possibile inserire il carattere <strong>{{separatorePathLogico}}</strong>
            </em>
            <em>* Campi obbligatori</em>
          </p>
        </div>
      </ng-template>
      <!-- FINE NUOVO/MODIFICA NOME CARTELLA -->
    </form>
  </ng-template>
  <!-- SPOSTAMENTO DOCUMENTO -->

  <ng-template [ngIf]="isSpostaDoc && isMain && secondStep">
    <div class="row" style="padding: 35px;">
      <p>Il documento sarà spostato nella sezione generica Documentazione allegata Fascicolo. Continuare?</p>
    </div>
    <div class="row">
      <p class="col-sm-3 col-xs-6">
        <button type="button" class="btn btn-outline-secondary btn-block" (click)="annulla();">Annulla</button>
      </p>
      <p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" (click)="confermaSpostaDoc();"
        [labelButton]="'Conferma'"></p>
    </div>
  </ng-template>
  <!-- FINE SPOSTAMENTO DOCUMENTO -->
</div>
<!-- </div> -->
